<!-- MODAL Direcciones-->
<div style="overflow-y: auto" mdbModal #direcciones="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: false }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Direcciones - RUT {{rutClienteFormateado}}
        </h4>

        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="direcciones.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Cabecera de botones -->

        <div class="filtros">
          <div class="row filtros-header m-0 mb-2" style="border-bottom: 1px solid #dee2e6">
            <div></div>
            <button type="button" size="sm" class="btn btn-sm" mdbBtn color="info" (click)="showModalAgregaDireccion()"
              mdbWavesEffect>
              Nueva dirección
            </button>
          </div>
          <div class="row filtros-body">

            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="nombre" class="form-control" placeholder="Nombre" required #nombre
                  [(ngModel)]="filtroDireccionNombre" />
                <label for="nombre">Nombre</label>
              </div>
            </div>

            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="direccion3" class="form-control" placeholder="Dirección" required
                  #direccion3 [(ngModel)]="filtroDireccionDireccion" />
                <label for="direccion3">Dirección</label>
              </div>
            </div>

          </div>

          <div class="row card-footer text-muted filtros-footer" style="
              border-top: 1px solid #dee2e6;
              border-bottom: 1px solid #dee2e6;
            ">
            <div></div>
            <button mdbBtn type="button" size="sm" color="secondary" mdbWavesEffect
              (click)="filtraGrillaDirecciones(1)">
              <mdb-icon fas icon="search"></mdb-icon>
              Buscar
            </button>
          </div>
        </div>

        <div class="table-responsive" style="margin-top: 20px">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col">ID</th> -->
                <th scope="col">Nombre</th>
                <th scope="col">Dirección</th>
                <th scope="col">Casa Matriz</th>
                <th scope="col">Estado</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let direccion of listaDirecciones">
                <!-- <td>{{ direccion.codigo }}</td> -->
                <td>{{ direccion.nombre }}</td>
                <td>{{ direccion.direccion_completa }}</td>
                <td>
                  <div *ngIf="direccion.activo; else inactivo">
                    <mdb-badge pill="true" success="true">Activo</mdb-badge>
                  </div>
                  <ng-template #inactivo>
                    <mdb-badge pill="true" warning="true">Inactivo</mdb-badge>
                  </ng-template>
                </td>
                <td>
                  <div *ngIf="direccion.es_principal">
                    <mdb-badge pill="true" success="true">Casa Matriz</mdb-badge>
                  </div>
                </td>
                <td>
                  <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                    (click)="showModalEditaDireccion(direccion);">
                    <mdb-icon fas icon="pen"></mdb-icon>
                  </button>
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listaDirecciones?.length > 0"></app-pagination>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="direcciones.hide()" mdbWavesEffect>
          Cerrar
        </button>

      </div>
    </div>
  </div>
</div>

<!-- MODAL editar direccion-->
<div mdbModal style="overflow-y: auto" #agregarDireccion="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-fluid" style="max-width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Agregar o editar dirección
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="agregarDireccion.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formDatosDirecciones">
          <div class="row" style="border-bottom: 1px solid #dee2e6">
            <div class="col-6">

            </div>
            <div class="col-3">
              <div class="switch info-switch">
                <label>
                  Inactivo
                  <input type="checkbox" formControlName="estadoDireccion" (change)="toggleCheckbox($event)" />
                  <span class="lever"></span> Activo
                </label>
              </div>
            </div>
            <div class="col">
              <mdb-checkbox [checked]="false" [Disabled]="checkbox1Checked == true" formControlName="direccDesp"
                (change)="onChangeForAddVendedor($event)">
                Dirección de Despacho
              </mdb-checkbox>
            </div>
          </div>

          <!-- <div class="md-form" style="margin-bottom: 0">
                                                    ID interno <strong>{{direccionCliente}}</strong>
                                                </div> -->

          <div class="row">
            <div class="col">
              <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos de dirección
                  </h5>
                </div>
              </div>
              <div class="row">
                <div class="col" style="max-width: 150px;">
                  <mdb-checkbox [checked]="true" formControlName="esCasaMatriz">Casa
                    matriz</mdb-checkbox>
                </div>
                <div class="col d-flex align-items-center" style="max-width: 200px;">
                  <div class="md-form">
                    <input value="" type="text" id="nombre3" class="form-control" placeholder="Nombre" required
                      formControlName="nombre" maxlength="100" #nombre3 />
                    <label for="nombre3">Nombre <app-required-field></app-required-field></label>
                    <div *ngIf="
                  formDatosDirecciones.get('nombre').invalid &&
                    (formDatosDirecciones.get('nombre').dirty ||
                    formDatosDirecciones.get('nombre').touched)
                  ">
                      <mdb-error *ngIf="
                    formDatosDirecciones.get('nombre').errors
                        .required
                    ">
                        Debe ingresar el nombre identificador de la dirección
                      </mdb-error>
                      <mdb-error *ngIf="
                    formDatosDirecciones.get('nombre').errors
                        .minlength
                    ">
                        El nombre debe tener un mínimo de 5 caracteres
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <mdb-select [options]="optionsDatosDireccionAgregarComuna" placeholder="Comuna"
                      [filterEnabled]="true" formControlName="comuna"></mdb-select>
                    <label>Comuna <app-required-field></app-required-field></label>
                    <div *ngIf="
                                                                                      formDatosDirecciones.get('comuna').invalid &&
                                                                                        (formDatosDirecciones.get('comuna').dirty ||
                                                                                        formDatosDirecciones.get('comuna').touched)
                                                                                      ">
                      <mdb-error *ngIf="
                                                                                        formDatosDirecciones.get('comuna').errors
                                                                                            .required
                                                                                        ">
                        La comuna es requerida
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="md-form" [ngStyle]="{'display': ShowLongLat == false ? 'block' : 'none'}">
                    <input value="" type="text" id="direccionFormEdita" name="direccionFormEdita" class="form-control"
                      placeholder="Ingrese dirección o selecione de la lista" formControlName="direccion"
                      autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="off"
                      (keydown.enter)="$event.preventDefault()" #direccionFormEdita />

                    <input type="hidden" formControlName="direccionFormateada">

                    <label for="direccion4">Dirección <app-required-field></app-required-field>
                    </label>

                  </div>

                  <div class="md-form" *ngIf="ShowLongLat === true">
                    <input value="" type="text" id="direccionFormEdita" name="direccion" class="form-control"
                      placeholder="Ingrese dirección" formControlName="direccNueva">


                    <label for="direccion4">Dirección <app-required-field></app-required-field>
                    </label>
                  </div>

                </div>
              </div>


              <div class="row">
                <div class="col">
                  <mdb-checkbox [checked]="false" formControlName="showCoordenadas"
                    (change)="ShowCoordenadasLatLong($event)">
                    <span style="font-size: 1rem">Ingreso manual de coordenadas</span>
                  </mdb-checkbox>
                </div>
              </div>

              <!-- <div class="md-form" >
                <label for="search">Dirección </label>

                <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()" placeholder="Buscar dirección en mapa"
                autocorrect="off" autocapitalize="off"  autocomplete="off"
                 spellcheck="off" type="text" #search>
              </div> -->
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <agm-map [fitBounds]="true" [usePanning]="true" [latitude]="latitude" [longitude]="longitude"
                      [zoom]="zoom" id="mapa">
                      <agm-marker [agmFitBounds]="true" [latitude]="latitude" [longitude]="longitude"
                        [markerDraggable]="true" (dragEnd)="markerDragEnd($event)" id="marcadores"></agm-marker>
                    </agm-map>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="latitud" class="form-control" placeholder="Latitud" required
                      #latitud formControlName="latitud" [readonly]="ShowLongLat === false" />
                    <label for="latitud">Latitud</label>
                    <div *ngIf="
                  formDatosDirecciones.get('latitud').invalid &&
                    (formDatosDirecciones.get('latitud').dirty ||
                    formDatosDirecciones.get('latitud').touched)
                  ">
                      <mdb-error *ngIf="
                    formDatosDirecciones.get('latitud').errors
                        .required
                    ">
                        La latitud es requerida
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="longitud" class="form-control" placeholder="Longitud" required
                      #longitud formControlName="longitud" [readonly]="ShowLongLat === false" />
                    <label for="longitud">Longitud</label>
                    <div *ngIf="
                  formDatosDirecciones.get('longitud').invalid &&
                    (formDatosDirecciones.get('longitud').dirty ||
                    formDatosDirecciones.get('longitud').touched)
                  ">
                      <mdb-error *ngIf="
                    formDatosDirecciones.get('longitud').errors
                        .required
                    ">
                        La longitud es requerida
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input value="" type="number" id="secuencia" class="form-control" formControlName="secuencia" />
                    <label for="secuencia">Secuencia</label>
                  </div>
                </div>
                <!-- <div class="col">
              <button mdbBtn type="button" color="info" mdbWavesEffect>
                <mdb-icon fas icon="map-marker-alt"></mdb-icon> Ver en Google Maps
              </button>
            </div> -->
              </div>
              <!-- <h5>Address: {{address}}</h5>
              <div>Latitude: {{latitude}}</div>
              <div>Longitude: {{longitude}}</div> -->
            </div>


            <!-- <div class="md-form" >
                <mdb-select
                  label="Región"
                  [options]="optionsRegion"
                  placeholder="Región"
                  [filterEnabled]="true"
                  formControlName="region"
                  (click)="obtenerDatosComunasAgregarDireccion()"
                ></mdb-select>
              </div>-->
            <div class="col">
              <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos dirección
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col">

                  <mdb-checkbox [checked]="true" formControlName="usaDireccionDespacho"
                    (change)="manejadorDireccionDespacho(true)">
                    Despachar a misma dirección
                  </mdb-checkbox>

                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <mdb-select label="Dirección" placeholder="Dirección" [options]="optionsDireccion"
                      [filterEnabled]="true" formControlName="direccionDespacho"></mdb-select>
                    <div *ngIf="
                                              formDatosDirecciones.get('direccionDespacho').invalid &&
                                                (formDatosDirecciones.get('direccionDespacho').dirty ||
                                                formDatosDirecciones.get('direccionDespacho').touched)
                                              ">
                      <mdb-error *ngIf="
                                                formDatosDirecciones.get('direccionDespacho').errors
                                                    .required
                                                ">
                        La dirección de despacho es requerida
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="localidad" class="form-control" placeholder="Localidad" #localidad
                      formControlName="localidad" />
                    <label for="localidad">Localidad</label>
                    <div *ngIf="
                                            formDatosDirecciones.get('localidad').invalid &&
                                              (formDatosDirecciones.get('localidad').dirty ||
                                              formDatosDirecciones.get('localidad').touched)
                                            ">
                      <mdb-error *ngIf="
                                              formDatosDirecciones.get('localidad').errors
                                                  .required
                                              ">
                        La localidad es requerida
                      </mdb-error>
                    </div>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <mdb-select label="Territorio" [options]="optionsTerritorioDireccion" placeholder="Territorio"
                      [filterEnabled]="true" formControlName="territorio">
                    </mdb-select>
                    <div *ngIf="
                                                                              formDatosDirecciones.get('territorio').invalid &&
                                                                                (formDatosDirecciones.get('territorio').dirty ||
                                                                                formDatosDirecciones.get('territorio').touched)
                                                                              ">
                      <mdb-error *ngIf="
                                                                                formDatosDirecciones.get('territorio').errors
                                                                                    .required
                                                                                ">
                        El territorio es requerido
                      </mdb-error>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <mdb-select label="Ruta" [options]="optionsRutaDireccion" placeholder="Ruta" [filterEnabled]="true"
                      formControlName="ruta"></mdb-select>
                    <div *ngIf="
                                                                              formDatosDirecciones.get('ruta').invalid &&
                                                                                (formDatosDirecciones.get('ruta').dirty ||
                                                                                formDatosDirecciones.get('ruta').touched)
                                                                              ">
                      <mdb-error *ngIf="
                                                                                formDatosDirecciones.get('ruta').errors
                                                                                    .required
                                                                                ">
                        La ruta es requerida
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mb-2" style="border-bottom: 1px solid #dee2e6">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Datos de contacto
                  </h5>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="contacto" class="form-control" placeholder="Contacto" #contacto
                      formControlName="contacto" />
                    <label for="contacto">Contacto</label>
                    <!-- <div *ngIf="
                                              formDatosDirecciones.get('contacto').invalid &&
                                                (formDatosDirecciones.get('contacto').dirty ||
                                                formDatosDirecciones.get('contacto').touched)
                                              ">
                                              <mdb-error *ngIf="
                                                formDatosDirecciones.get('contacto').errors
                                                    .required
                                                ">
                                                El contacto es requerido
                                              </mdb-error>
                                            </div> -->
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="fijo" class="form-control" placeholder="Fijo" #fijo
                      formControlName="fijo" />
                    <label for="fijo">Fijo</label>
                    <!-- <div *ngIf="
                                            formDatosDirecciones.get('fijo').invalid &&
                                              (formDatosDirecciones.get('fijo').dirty ||
                                              formDatosDirecciones.get('fijo').touched)
                                            ">
                                              <mdb-error *ngIf="
                                              formDatosDirecciones.get('fijo').errors
                                                  .required
                                              ">
                                                El teléfono fijo es requerido
                                              </mdb-error>
                                            </div> -->
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input value="" type="text" id="movil" class="form-control" placeholder="Movil" #movil
                      formControlName="movil" />
                    <label for="movil">Movil</label>
                    <!-- <div *ngIf="
                                            formDatosDirecciones.get('movil').invalid &&
                                              (formDatosDirecciones.get('movil').dirty ||
                                              formDatosDirecciones.get('movil').touched)
                                            ">
                                              <mdb-error *ngIf="
                                              formDatosDirecciones.get('movil').errors
                                                  .required
                                              ">
                                                El móvil es requerido
                                              </mdb-error>
                                            </div> -->
                  </div>
                </div>
                <div class="col">
                  <div class="md-form">
                    <input value="" type="email" id="email" class="form-control" placeholder="Email" #email
                      formControlName="email" />
                    <label for="email">Email</label>
                    <div *ngIf="
                                            formDatosDirecciones.get('email').invalid &&
                                              (formDatosDirecciones.get('email').dirty ||
                                              formDatosDirecciones.get('email').touched)
                                            ">
                      <!-- <mdb-error *ngIf="
                                              formDatosDirecciones.get('email').errors
                                                  .required
                                              ">
                                                El email es requerido
                                              </mdb-error> -->
                      <mdb-error *ngIf="
                                                                formDatosDirecciones.get('email').errors
                                                  .email
                                              ">
                        El email es inválido
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="HidenEmpresaHeredada === true">
                <div class="col">
                  <mdb-checkbox [checked]="true" formControlName="showEmpresaHeredada" (change)="checkEmpresa($event)"
                    [disabled]="true">
                    Visibilidad Savory
                  </mdb-checkbox>


                </div>
              </div>
              <div class="row" *ngIf="HidenEmpresaHeredada === true"
                [ngStyle]="{'display': formDatosDirecciones.get('showEmpresaHeredada').value === true ? 'flex' : 'none'}">
                <div class="col-auto" style="margin-top:1%;">
                  <label for="empresaHeredada" class="form-check-label">Empresa Destino</label>
                </div>
                <div class="col-3 mdb-form">
                  <mdb-select [options]="optionsEmpresaAlterna" id="empresaHeredada" placeholder="Seleccionar empresa"
                    [filterEnabled]="true" formControlName="EmpresaAlteSel" [disabled]="true"></mdb-select>
                </div>
              </div>

              <div class="row" style="border-bottom: 1px solid #dee2e6">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Referencias
                  </h5>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <!--Basic textarea-->
                  <div class="md-form">
                    <textarea type="text" id="form7" class="md-textarea form-control" placeholder="Escribe aquí"
                      mdbInput formControlName="referencias" maxlength="160"></textarea>
                    <div *ngIf="
                                              formDatosDirecciones.get('referencias').invalid &&
                                                (formDatosDirecciones.get('referencias').dirty ||
                                                formDatosDirecciones.get('referencias').touched)
                                              ">
                      <mdb-error *ngIf="
                                                formDatosDirecciones.get('referencias').errors
                                                    .maxlength
                                                ">
                        Las referencias no pueden contener más de 2000 caracteres
                      </mdb-error>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" style="border-bottom: 1px solid #dee2e6">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Facturar a
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col dato" style="min-width: 350px; display: flex; align-items: center;">
                  <div class="form-check form-check-inline" style="margin-right: 20px">
                    <input type="radio" class="form-check-input" mdbInput id="producto_libre_afecto"
                      [value]="RB_CASAMATRIZ_" formControlName="facturarACasaMatriz" />
                    <label class="form-check-label" for="producto_libre_afecto">Casa matriz</label>
                  </div>

                  <!-- Material inline 2 -->
                  <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" mdbInput id="producto_libre_exento"
                      [value]="RB_DIRECCION_ACT" formControlName="facturarACasaMatriz" />
                    <label class="form-check-label" for="producto_libre_exento">Esta dirección</label>
                  </div>
                </div>
              </div>


              <div class="row" style="border-bottom: 1px solid #dee2e6">
                <div class="col">
                  <h5 class="modal-title w-100 text-left" id="myModalLabel">
                    Agregar vendedor
                  </h5>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="md-form">
                    <mdb-select label="Vendedor" [options]="optionsVendedor" placeholder="Seleccionar vendedor"
                      [filterEnabled]="true" formControlName="VendedorSel"></mdb-select>
                  </div>
                </div>
                <!-- <div class="col">
                                                        <div class="md-form">
                                                            <mdb-select label="Rubro" [options]="optionsRubro" placeholder="Seleccionar Rubro"
                                                                [filterEnabled]="true" formControlName="RubroSel"></mdb-select>
                                                        </div>
                                                    </div> -->
                <div class="col">
                  <button size="sm" class="btn btn-sm" [disabled]="disableAddVendedor === true" mdbBtn type="button"
                    color="info" mdbWavesEffect (click)="agregaVendedorRubro()">
                    Agregar
                  </button>
                </div>
              </div>
            </div>



          </div>

          <!-- FIN DE MODAL-BODY -->
        </form>
        <div class="card mb-2 wow detalle-cliente">
          <div class="card-body justify-content-between">
            <div class="table-responsive">
              <table class="table  table-striped table-hover table-sm align-middle mb-5">
                <thead class="grey lighten-2">
                  <tr>
                    <th colspan="3"></th>
                    <th colspan="7">IPT</th>
                    <th colspan="2"></th>
                    <th [ngStyle]="{'display': permiteUnidadNegocio == true?'block':'none'}"></th>
                  </tr>
                  <tr>
                    <th scope="col">Cod.</th>
                    <th scope="col">Vendedor</th>
                    <!-- <th scope="col">Rubro</th> -->
                    <th scope="col">L</th>
                    <th scope="col">M</th>
                    <th scope="col">Mi</th>
                    <th scope="col">J</th>
                    <th scope="col">V</th>
                    <th scope="col">S</th>
                    <th scope="col">D</th>
                    <th *ngIf="!permiteUnidadNegocio" class="text-center">Cobranza</th>
                    <th *ngIf="permiteUnidadNegocio" scope="col" style="width: 12%;">Unidad Negocio</th>
                    <th scope="col">Rubros</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let rubroipt of listaClienteVendedorRubroIPTFixed; let i = index">
                    <tr>
                      <td>{{rubroipt.vendedor_codigo}}</td>
                      <td>{{rubroipt.nombreVendedor}}</td>
                      <!-- <td>{{rubroipt.nombreRubro}}</td> -->
                      <td>
                        <mdb-checkbox *ngIf="rubroipt.lunes" class="checkbox-teal" [checked]="true"
                          (click)="CambiaIPT('lunes', rubroipt, i)">
                        </mdb-checkbox>
                        <mdb-checkbox *ngIf="!rubroipt.lunes" class="checkbox-teal"
                          (click)="CambiaIPT('lunes', rubroipt, i)"></mdb-checkbox>
                      </td>
                      <td>
                        <mdb-checkbox *ngIf="rubroipt.martes" [checked]="true" class="checkbox-teal"
                          (click)="CambiaIPT('martes', rubroipt, i)">
                        </mdb-checkbox>
                        <mdb-checkbox *ngIf="!rubroipt.martes" class="checkbox-teal"
                          (click)="CambiaIPT('martes', rubroipt, i)"></mdb-checkbox>
                      </td>

                      <td>
                        <mdb-checkbox *ngIf="rubroipt.miercoles" [checked]="true" class="checkbox-teal"
                          (click)="CambiaIPT('miercoles', rubroipt, i)">
                        </mdb-checkbox>

                        <mdb-checkbox *ngIf="!rubroipt.miercoles" class="checkbox-teal"
                          (click)="CambiaIPT('miercoles', rubroipt, i)"></mdb-checkbox>
                      </td>

                      <td>
                        <mdb-checkbox *ngIf="rubroipt.jueves" [checked]="true" class="checkbox-teal"
                          (click)="CambiaIPT('jueves', rubroipt, i)">
                        </mdb-checkbox>
                        <mdb-checkbox class="checkbox-teal" *ngIf="!rubroipt.jueves"
                          (click)="CambiaIPT('jueves', rubroipt, i)"></mdb-checkbox>
                      </td>

                      <td>
                        <mdb-checkbox *ngIf="rubroipt.viernes" [checked]="true" class="checkbox-teal"
                          (click)="CambiaIPT('viernes', rubroipt, i)">
                        </mdb-checkbox>
                        <mdb-checkbox *ngIf="!rubroipt.viernes" class="checkbox-teal"
                          (click)="CambiaIPT('viernes', rubroipt, i)"></mdb-checkbox>
                      </td>

                      <td>
                        <mdb-checkbox *ngIf="rubroipt.sabado" [checked]="true" class="checkbox-teal"
                          (click)="CambiaIPT('sabado', rubroipt, i)">
                        </mdb-checkbox>
                        <mdb-checkbox *ngIf="!rubroipt.sabado" class="checkbox-teal"
                          (click)="CambiaIPT('sabado', rubroipt, i)"></mdb-checkbox>
                      </td>

                      <td>
                        <mdb-checkbox *ngIf="rubroipt.domingo" [checked]="true" class="checkbox-teal"
                          (click)="CambiaIPT('domingo', rubroipt, i)">
                        </mdb-checkbox>
                        <mdb-checkbox *ngIf="!rubroipt.domingo" class="checkbox-teal"
                          (click)="CambiaIPT('domingo', rubroipt, i)"></mdb-checkbox>
                      </td>

                      <td *ngIf="!permiteUnidadNegocio" class="text-center">
                        <div class="form-check">
                          <input type="radio" class="form-check-input" [id]="rubroipt.front_id"
                            [checked]="rubroipt.es_cobrador" (change)="handleChangeCobrador(rubroipt)" mdbInput />
                          <label class="form-check-label" [for]="rubroipt.front_id"></label>
                        </div>
                      </td>
                      <td *ngIf="permiteUnidadNegocio">
                        <mdb-select (ngModelChange)="unidadNegocioChange(rubroipt, $event)" style="max-width: 200px;"
                          [options]="optionsUnidadesDeNegocio" placeholder="Selec. Unidad Negocio"
                          [(ngModel)]="rubroipt.unidad_negocio_codigo" name="unidad_negocio_codigo"
                          #unidad_negocio_codigo="ngModel" [multiple]="true">
                        </mdb-select>
                        <div *ngIf="!unidad_negocio_codigo.valid" style="color: #f44336;">Selecciones Unidad de Negocio
                        </div>
                      </td>
                      <td>
                        <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                          (click)="verRubros(rubroipt, i)">
                          <mdb-icon fas icon="eye"></mdb-icon>
                        </button>
                      </td>
                      <td>
                        <button mdbBtn type="button" size="sm" color="primary" mdbWavesEffect class="btn-actions-sm"
                          (click)="eliminaVendedorRubro(rubroipt)">
                          <mdb-icon fas icon="trash"></mdb-icon>
                        </button>
                      </td>
                    </tr>
                    <ng-container *ngIf="rubroipt.rubrosVisibles">
                      <tr>
                        <td colspan="100%" style="text-align: center">
                          <div
                            style="white-space: break-spaces; display: flex; justify-content: flex-start; flex-wrap: wrap;">
                            <ng-container *ngFor="let rubro of rubroipt.rubros">
                              <div class="chip green lighten-2 white-text"
                                style="position: unset; padding-right: 28px; cursor: default;">
                                {{rubro.nombreRubro}}
                                <!-- <mdb-icon fas icon="times" class="close"
                                                                  style="position: relative; right: -32px;"
                                                                  (click)="eliminaRubroAssigned(rubroipt, rubro)">
                                                              </mdb-icon> -->
                              </div>
                            </ng-container>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>

      <div class="modal-footer justify-content-between">
        <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="agregarDireccion.hide()" mdbWavesEffect>
          Cerrar
        </button>
        <button type="button" size="sm" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
          [disabled]="!formDatosDirecciones.valid" (click)="agregarEditarDireccion();">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>
